import { useSearchParams, Link } from "react-router-dom";
import Wizard from "./Wizard";
import "./Generate.css";

export default function Generate({ config, onSaveOffers, onCreateAsset, isCreatingAsset }) {
  const [searchParams] = useSearchParams();
  const brandSlug = searchParams.get("brand");

  const entry = (config?.config ?? []).find((item) => item.brand.slug === brandSlug);

  if (!entry) {
    return (
      <div className="generate-page__not-found">
        <p>Pick a brand to generate from first.</p>
        <Link to="/brands" className="generate-page__back-link">
          Back to Brands
        </Link>
      </div>
    );
  }

  return (
    <Wizard
      brand={entry.brand}
      identity={entry.identity}
      references={entry.references}
      offers={entry.offers}
      credits={config.credits}
      appConfig={config}
      onSaveOffers={onSaveOffers}
      onCreateAsset={onCreateAsset}
      isCreatingAsset={isCreatingAsset}
    />
  );
}